<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.3733 19.4036L5 22.6923L7.14286 33.75H32.8571L35 22.6923L28.6267 19.4036C27.0436 22.665 23.7751 24.9039 20 24.9039C16.2249 24.9039 12.9564 22.665 11.3733 19.4036Z"
      class="fill-current"
    />
    <path
      d="M28.5714 13.8461C28.5714 18.7317 24.7339 22.6923 20 22.6923C15.2661 22.6923 11.4286 18.7317 11.4286 13.8461C11.4286 8.96055 15.2661 5 20 5C24.7339 5 28.5714 8.96055 28.5714 13.8461Z"
      class="fill-current"
    />
  </svg>
</template>
